import { Navigate, NavLink, Outlet } from "react-router-dom";
import { useAdminAuth } from "@/hooks/useAdminAuth";
import { Button } from "@/components/ui/button";
import { LogOut } from "lucide-react";

const NAV_ITEMS = [
  { to: "/admin", label: "Oversikt", end: true },
  { to: "/admin/events", label: "Arrangementer" },
  { to: "/admin/orders", label: "Ordrer" },
  { to: "/admin/products", label: "Produkter" },
  { to: "/admin/donors", label: "Fastgivere" },
  { to: "/admin/analytics", label: "Analyse" },
];

const AdminLayout = () => {
  const { loading, user, isAdmin, signOut } = useAdminAuth();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center text-muted-foreground">
        Laster …
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/admin/login" replace />;
  }

  if (!isAdmin) {
    return (
      <div className="mx-auto flex min-h-screen max-w-md flex-col items-center justify-center gap-4 px-6 text-center">
        <h1 className="text-2xl font-semibold">Ingen tilgang</h1>
        <p className="text-muted-foreground">
          Brukeren <span className="font-medium">{user.email}</span> står ikke på admin-listen.
          Ta kontakt med Vibbing hvis du skulle hatt tilgang.
        </p>
        <Button onClick={() => void signOut()}>Logg ut</Button>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background">
      <header className="border-b bg-card">
        <div className="mx-auto flex max-w-6xl items-center justify-between px-6 py-4">
          <div className="flex items-center gap-8">
            <span className="text-sm font-semibold uppercase tracking-wider text-muted-foreground">
              Håp Naturlab admin
            </span>
            <nav className="flex gap-4">
              {NAV_ITEMS.map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  end={item.end}
                  className={({ isActive }) =>
                    `text-sm font-medium transition-colors ${
                      isActive
                        ? "text-foreground"
                        : "text-muted-foreground hover:text-foreground"
                    }`
                  }
                >
                  {item.label}
                </NavLink>
              ))}
            </nav>
          </div>
          <div className="flex items-center gap-3">
            <span className="hidden text-sm text-muted-foreground sm:inline">
              {user.email}
            </span>
            <Button variant="ghost" size="sm" onClick={() => void signOut()}>
              <LogOut className="mr-2 h-4 w-4" />
              Logg ut
            </Button>
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-6xl px-6 py-8">
        <Outlet />
      </main>
    </div>
  );
};

export default AdminLayout;
